import React,{useState, useContext} from 'react'
import { GlobalContext } from '../../../../context/provider';
import customer_sell_invoiceaction from '../../../../context/action/mizania/customer_sell_invoiceaction';
import Mizania_customer_sell_table from './mizania_customer_sell_table';
import customer_loan_inaction from '../../../../context/action/mizania/customer_loan_inaction';
import Mizania_customer_loan_in_table from './mizania_customer_loan_in_table';
import customer_ledger_action from '../../../../context/action/mizania/customer_ledger_action';
import Mizania_customer_ledger_table from './mizania_customer_ledger_table';

const Mizania_customer_ledger = () => {
  const {initState, clear} = useContext(GlobalContext);
  
  const [table_type,settable_type]=useState('');
  const [invoice,setinvoice]=useState([]);
  const [loan_back,setloan_back]=useState([]);
  const [ledger,setledger]=useState([]);
  var customer_id = initState?.mizania_customer_id;
  var customer_name = initState?.mizania_customer_name;
  var mizania_date = initState?.mizania_date;

  return (
    <div className="min-h-screen p-4 sm:p-6 lg:p-8 bg-slate-50">
      <div className="w-full h-16 sm:h-20 lg:h-24 flex justify-center items-center text-xl sm:text-2xl md:text-3xl lg:text-4xl mb-4 sm:mb-6">
            تۆمارەکانی - {customer_name} - بۆ ساڵی ({mizania_date})
      </div>
      <div className="flex flex-col sm:flex-row justify-center gap-4 sm:gap-6 lg:gap-8">
          <div className="flex justify-center items-center cursor-pointer w-full sm:w-1/2 rounded-lg bg-white text-center shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)] hover:shadow-lg transition-shadow duration-300" onClick={()=>{
              customer_sell_invoiceaction(customer_id, mizania_date)(clear).then((res)=>{
                  setinvoice(res);
                  settable_type('invoice');
              });
          }}>
              <h5 className="py-6 sm:py-8 lg:py-10 px-4 text-2xl sm:text-3xl lg:text-4xl font-medium leading-tight text-neutral-800">
                  وەسڵی فرۆشراو
              </h5>
          </div>
          <div className="flex justify-center items-center cursor-pointer w-full sm:w-1/2 rounded-lg bg-white text-center shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)] hover:shadow-lg transition-shadow duration-300" onClick={()=>{
              customer_loan_inaction(customer_id, mizania_date)(clear).then((res)=>{
                  setloan_back(res);
                  settable_type('loan_back');
              });
          }}>
              <h5 className="py-6 sm:py-8 lg:py-10 px-4 text-2xl sm:text-3xl lg:text-4xl font-medium leading-tight text-neutral-800">
                  قەرزی گەڕاوە
              </h5>
          </div>
      </div>
      <div className="mt-10 flex flex-col sm:flex-row justify-center gap-4 sm:gap-6 lg:gap-8">
          <div className="flex justify-center items-center cursor-pointer w-full rounded-lg bg-white text-center shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)] hover:shadow-lg transition-shadow duration-300" onClick={()=>{
              customer_ledger_action(customer_id, mizania_date)(clear).then((res)=>{
                  setledger(res);
                  settable_type('ledger');
              });
          }}>
              <h5 className="py-6 sm:py-8 lg:py-10 px-4 text-2xl sm:text-3xl lg:text-4xl font-medium leading-tight text-neutral-800">
                  کەشف حساب
              </h5>
          </div>
      </div>
      <div className="mt-6 sm:mt-8 lg:mt-10">
        {table_type == "invoice"?<Mizania_customer_sell_table invoice={invoice} />:table_type == "loan_back"?<Mizania_customer_loan_in_table loan_in={loan_back} />:table_type == "ledger"?<Mizania_customer_ledger_table ledger={ledger} mizania_date={mizania_date} />:null}
      </div>
    </div>
  )
}

export default Mizania_customer_ledger